'use client';
import React from 'react';
import { Div, Media, Text } from '@pezeshk-book/ui-kit';
import Image from '@elements/image';
import BackgroundImage from '../sub-component/background-image';
import Consults from '@layouts/consult';

const imageSize = {
  HD: {
    width: '0',
    height: '0',
  },
  MidHD: {
    width: '220px',
    height: '270px',
  },
  FullHD: {
    width: '420px',
    height: '450px',
  },
};

const ConsultSection = ({ userItems, translate }: any) => {
  if (process.env.APPOINTMENT_SERVICE_ACTIVE === 'true' && process.env.CONSULT_SERVICE_ACTIVE === 'true') {
    return (
      <Div className={'w-full flex-col'}>
        <Text typography={'xl'} type={'bold'} className={'mt-12'} color={'grey.900'}>
          {translate.title}
        </Text>
        <Div className={'justify-between pt-8 md:pt-24 pb-36 w-full flex-row sm:flex-col-reverse md:flex-row-reverse'}>
          <Div className={'flex-col w-full md:w-4/5'}>
            <Consults
              desktopSlides={4}
              data={userItems}
              translate={translate.buttons}
            />
          </Div>
          <Media greaterThan={'sm'}>
            <BackgroundImage imageSize={imageSize}>
              <Image
                className={'relative object-contain'}
                sizes={'(max-width: 639px) 50vw, (max-width: 1023px) 33vw, 25vw'}
                alt={'image'}
                src={'/images/home-screen/background-svg/consult.png'}
              />
            </BackgroundImage>
          </Media>
        </Div>
      </Div>
    );
  }

  return null;
};

export default ConsultSection;
